module.exports = __webpack_public_path__ + "static/media/protfolio-min.ca8bef79.png";